import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useLanguage } from '../utils/LanguageContext';
import { addAcceptedAgreementsClientSchema } from '../shared/validations/userValidations';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { ExternalLink } from './common/CommonComponents.js';
import { useAsync } from './common/commonHooks.js';

const DocumentAcceptance = ({ onFinish }) => {
  const { lang } = useLanguage(translations);
  const { user, api } = useAuth();
  const requiredAgreements = useAsync(api.getRequiredAgreements);

  if (!requiredAgreements) {
    return;
  }

  const initialValues = { acceptedAgreements: requiredAgreements.map(({ agreementName }) => ({ agreementName })) };
  const handleSubmit = async ({ acceptedAgreements }) => await api.acceptAgreements({ acceptedAgreements });

  return (
    <ValidatedForm
      key="agreementAcceptance"
      schema={addAcceptedAgreementsClientSchema}
      initialValues={initialValues}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <p>{lang('acceptTermsDescription')}</p>
      <ul>
        {requiredAgreements.map(({ agreementLabel, url }, i) => (
          <li key={i}>
            <ExternalLink href={url}>{agreementLabel}</ExternalLink>
          </li>
        ))}
      </ul>

      {!user.isPayrollAdmin && <p>{lang('acceptTermsUserRequiredText')}</p>}
      <p>{lang('acceptTermsESignatureText')}</p>
      <FormInput name="agreementsAccepted" type="checkbox" />
      <FormSubmit>{lang('finish')}</FormSubmit>
    </ValidatedForm>
  );
};

export default DocumentAcceptance;
